import useNLTrackers from './useNLTrackers';
import useNLAAUITracker from './useNLAAUITracker';
import useAdobeLaunchTracker from './useAdobeLaunchTracker';

const useTrackers = () => {
	useNLTrackers();
	useNLAAUITracker();
	useAdobeLaunchTracker();
};

export default useTrackers;
